import gql from 'graphql-tag';
export default gql`
  query getSfAccountAndOppMeta(
    $region: String
    $companyABN: String
    $companyName: String
    $introducerOrgName: String
    $salesforceAccountId: String
  ) {
    getSfAccountAndOppMeta(
      region: $region
      companyABN: $companyABN
      companyName: $companyName
      introducerOrgName: $introducerOrgName
      salesforceAccountId: $salesforceAccountId
    ) {
      accountId
      opportunityId
      opportunityStageName
    }
  }
`;
